import { Injectable } from '@angular/core';

@Injectable()
export class FileService {

  constructor() { }

  public getUrl(fileId: string) { return `/api/v1/file/${fileId}` };
}
